import { useQuotationsStore } from '../store/quotations'

/**
 * Recharge currentQuotation depuis le cache liste quand on n’est pas en simple changement d’onglet
 * (même quoteid : produits / infos / contact). Sinon, retour liste → même id réutilisait le brouillon Pinia.
 */
export default defineNuxtRouteMiddleware(async (to, from) => {
  const quoteid = to.params.quoteid
  if (quoteid === undefined || quoteid === null || String(quoteid) === 'new') return

  const toId = String(quoteid)
  const fromQuoteId = from?.params?.quoteid

  const sameQuoteTabSwitch =
    fromQuoteId !== undefined &&
    fromQuoteId !== null &&
    String(fromQuoteId) === toId

  if (sameQuoteTabSwitch) return

  const quotationsStore = useQuotationsStore()
  await quotationsStore.fetchQuotations(false)

  const id = Number(quoteid)
  if (!Number.isFinite(id)) return

  const found = quotationsStore.quotations.data?.find((elt) => elt.id === id)
  if (!found) return

  quotationsStore.setCurrentQuotation(id, { force: true })
})
